import { Box, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import Header from "../../../components/Header";
import { LOCATIONS } from "./constants";

const Locations = () => {
  return (
    <Box maxWidth={1000} width={{ xs: "90%", lg: "80%" }} py={8} m="auto">
      <Box>
        <Stack spacing={4}>
          <Header
            label="locations"
            title="Available in your favourite cities"
          />
          <Stack direction={{ xs: "column", md: "row" }} spacing={3}>
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(6, 1fr)",
              }}
              gap={3}
            >
              {LOCATIONS.map(({ img, title, desc }, idx) => {
                const mdStyles =
                  idx === 3
                    ? { gridColumn: "2 / span 2" }
                    : idx === 4
                      ? { gridColumn: "4 / span 2" }
                      : { gridColumn: "span 2" };

                return (
                  <Box
                    key={idx}
                    sx={{
                      ...(idx >= 3 ? { md: mdStyles } : {}),
                    }}
                    gridColumn={{
                      xs: "span 1",
                      sm: "span 1",
                      md: mdStyles.gridColumn,
                    }}
                    data-sal="fade-up"
                    data-sal-delay={idx * 100}
                  >
                    <Stack spacing={2} textAlign="center">
                      <img
                        width="100%"
                        style={{ borderRadius: 24, aspectRatio: "2/1.5" }}
                        src={img}
                        alt={title}
                      />

                      <Box>
                        <Typography variant="h6">{title}</Typography>

                        <Typography variant="body2" color="text.secondary">
                          {desc}
                        </Typography>
                      </Box>
                    </Stack>
                  </Box>
                );
              })}
            </Box>
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default Locations;
